import { Request } from '../../config/requests';
import { getToken } from '../../config/token';
import { recordImage } from '../../services/images';
import { updateAnalyseImagePayload, updateMissedChip } from '../../config/actions';
import { createMergedPdf } from './createMergedPdf';

export async function handleParagraphOcr({
  allPhotos,
  ocrDetails,
  data,
  setOcrDetails,
  claim_id,
  noAnalyze = false,
  currentPetInfo,
  setDocCounter,
  customerComment,
  errorHandler,
  dispatch
}) {
  let attachedFiles = [];
  setDocCounter(allPhotos.length);

  for (let i = 0; i < allPhotos.length; i++) {
    attachedFiles.push(allPhotos[i]);
  }
  const mergedPdf = await createMergedPdf(attachedFiles);

  // Upload single merged PDF
  const attachedFilesId = await recordImage([mergedPdf], { claimId: claim_id, policyId: currentPetInfo?.policyId })
    .then((res) => {
      const data = res.json();
      return data;
    })
    .then((res) => {
      return res.data;
    });

  if (!noAnalyze) {
    try {
      setOcrDetails({
        ...ocrDetails,
        loading: true,
        pictures: attachedFiles,
      });

      const claimRecord = await Request({
        method: 'post',
        route: 'api/claims/analyse-image',
        token: getToken(),
        values: {
          picturesId: attachedFilesId,
          ocrDetails,
          claim_id,
          data,
          customerComment,
          policy_id: currentPetInfo.policyId,
          pet: currentPetInfo.nameOfPet,
        },
      }).then((res) => res.json());

      setOcrDetails(claimRecord.newOcrDetails);
      dispatch(updateAnalyseImagePayload(claimRecord.customerComment));
      dispatch(updateMissedChip(claimRecord.newOcrDetails.details?.ChipNumberMissed?.content || false));
    } catch (e) {
      console.error('Error: ', e);
      errorHandler(e);
    }
  }

  return { attachedFilesId };
}
